import { logout } from './methods/logout';
import { refreshToken } from './methods/refreshToken';
import { validateEmailAddress } from './methods/validateEmailAddress';
import { setTokens } from './methods/setTokens';
import { isLoggedIn } from './methods/isLoggedIn';
import { init } from './methods/init';
import { login } from './methods/login';
import { signup } from './methods/signup';
import { ssoLogin } from './methods/ssoLogin';
import { ssoSignup, ssoAuthTokens } from './methods/ssoSignup';
import { resetPassword } from './methods/resetPassword';
import { sendResetPasswordEmail } from './methods/sendResetPasswordEmail';
import { doMfa, sendEmail, getMfaToken, isUserMfa } from './methods/mfa';
import { listen, removeListener, onError } from './utils/eventManager';
import { getAuthGateUrl, getCookieDomain } from './utils/config';
import { MfaRequiredError, GqlError, ApwError, PxError, isPxError } from './utils/GqlError';
import { ErrorCodes, SsoProviders, SsoUserCredentials, SsoUserDetails, UserCredentials, UserProfile } from './__generated__/auth-gate';
import { Environment, getClientId, setClientId } from './utils/config';
import { StudentType, UserType, TokenType, ResetPasswordStatus } from './__generated__/auth-gate';
import { sendMfaByApp } from './methods/sendMfaByApp';
export { init, doMfa, login, logout, listen, signup, onError, PxError, GqlError, ssoLogin, ApwError, UserType, getCookieDomain, TokenType, ssoSignup, ssoAuthTokens, setTokens, sendEmail, isUserMfa, isLoggedIn, ErrorCodes, Environment, StudentType, SsoUserCredentials, SsoUserDetails, UserCredentials, UserProfile, setClientId, getClientId, getMfaToken, SsoProviders, validateEmailAddress, refreshToken, resetPassword, removeListener, getAuthGateUrl, ResetPasswordStatus, sendResetPasswordEmail, MfaRequiredError, sendMfaByApp, isPxError };
export var Errors = {
  GqlError: GqlError,
  ApwError: ApwError,
  MfaRequiredError: MfaRequiredError
};
var OneAuthSDK = {
  init: init,
  doMfa: doMfa,
  login: login,
  listen: listen,
  logout: logout,
  signup: signup,
  Errors: Errors,
  ssoLogin: ssoLogin,
  sendEmail: sendEmail,
  ssoSignup: ssoSignup,
  ssoAuthTokens: ssoAuthTokens,
  setTokens: setTokens,
  isLoggedIn: isLoggedIn,
  ErrorCodes: ErrorCodes,
  getMfaToken: getMfaToken,
  refreshToken: refreshToken,
  SsoProviders: SsoProviders,
  validateEmailAddress: validateEmailAddress,
  resetPassword: resetPassword,
  removeListener: removeListener,
  sendResetPasswordEmail: sendResetPasswordEmail
};
export default OneAuthSDK;